import { Pipe, PipeTransform } from '@angular/core';
import { CashTransactionType } from '../constants/cash-transaction-types';

@Pipe({
  name: 'fundTransactionType'
})
export class FundTransactionTypePipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
           const transactionTypes = CashTransactionType.types;
           const found = transactionTypes.find(e => e.value === value);
           if (found) {
             return found.name;
           }
           return '-';
  }

}
